/**
 * Office announcements stored on `Schools.messages` (see `/api/schools/viewmessages`).
 * Read state is tracked with legacy `view`: unread → missing / empty array / empty object / empty string.
 */

export function normalizeSchoolOfficeMessages(raw) {
  return Array.isArray(raw) ? raw : [];
}

export function isOfficeMessageUnread(m) {
  if (!m || typeof m !== 'object') return false;
  const view = m.view;
  if (view == null) return true;
  if (Array.isArray(view)) return view.length === 0;
  if (typeof view === 'string') return view.trim() === '';
  if (typeof view === 'object') {
    const keys = Object.keys(view);
    if (keys.length === 0) return true;
    if ('read' in view) return view.read !== true && view.read !== 'yes';
    return false;
  }
  return true;
}

/** Stable row identity for matching DB rows (no canonical id in schema). */
export function officeMessageMatchKey(m) {
  const body = String(m?.message ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 160);
  return `${String(m?.date ?? '')}\t${String(m?.time ?? '')}\t${String(m?.subject ?? '')}\t${body}`;
}
